import { useTranslation } from "react-i18next"
import { passwordRegex } from "@/app/account/constants/regex"

export default function useGetPwdErrMsg(pwd?: string, compare?: string) {
  const { t } = useTranslation("")

  if (pwd === undefined) {
    return
  }

  if (pwd === "") {
    return t("rules.required")
  }

  if (!passwordRegex.test(pwd as string)) {
    return t("rules.passwordError")
  }

  if (pwd !== compare && compare) {
    return t("rules.passwordIncorrect")
  }
}
